var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"utc-timer"},[_c('div',{staticStyle:{"display":"inline-block","width":"4rem"}},[_vm._v(_vm._s(_vm.time))]),_vm._v(" UTC "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }